import { render, staticRenderFns } from "./AdditionalInformationTab.vue?vue&type=template&id=0a36cfdc&scoped=true"
import script from "./AdditionalInformationTab.vue?vue&type=script&lang=js"
export * from "./AdditionalInformationTab.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInformationTab.vue?vue&type=style&index=0&id=0a36cfdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a36cfdc",
  null
  
)

export default component.exports